import { FieldArray, Form, Formik } from "formik";
import React from "react";
import FormInput from "../../../../Universal/FormInput.component";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import PlusBtnIcon from "../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
import CrossBtnIcon from "../../../../../assets/Icons/Universal/CrossHoloIcon.svg";

const SalarySlabForm = ({
  outputData,
  ediData = {
    grade: "",
    position: [],
    yearlyCtc: "",
    monthlySalary: "",
    deducation: [{ amount: "", cause: "" }],
    grossSalary: "",
  },
}) => {
  const positionSuggestions = ["Teacher", "Staffs", "Hod", "OEM"];
  return (
    <Formik
      initialValues={ediData}
      onSubmit={(values) => {
        outputData(values);
      }}
      enableReinitialize
    >
      {({ values, setFieldValue, touched, errors }) => (
        <Form
          className="w-full flex-col align-left justify-start g-2 overflow-hide"
          style={{ height: "26rem" }}
        >
          <h3 className="color-textGray poppins-medium t-18 weight-500">
            Slab {ediData?.slabNo}
          </h3>
          <div className="w-full flex-col align-left justify-start h-full  scroll-y  pr-1">
            <div className="w-full flex-col align-left justify-start g-2">
              <div className="w-full flex-row align-left justify-start g-2">
                <div
                  className="flex-col align-left justify-start g-1"
                  style={{ width: "35%" }}
                >
                  <FormInput
                    name="grade"
                    type="text"
                    label="Grade"
                    placeholder="Enter any grade here"
                    touched={touched}
                    errors={errors}
                    containerClass={"w-full"}
                  />
                  <DropDownInput
                    multiple
                    label="position"
                    placeholder="Choose any designation"
                    value={values.position}
                    setFieldValue={(val) => setFieldValue("position", val)}
                    suggestionList={positionSuggestions}
                  />
                </div>
                <div
                  className="flex-col align-left justify-start g-1 flex-1 pl-1"
                  style={{ borderLeft: "2px solid var(--borderGray)" }}
                >
                  <div className="w-full flex-row align-left justify-between g-05">
                    <FormInput
                      name="yearlyCtc"
                      type="number"
                      label="Yearly CTC (INR)"
                      placeholder="Enter CTC"
                      touched={touched}
                      errors={errors}
                      containerClass={"w-full"}
                    />
                    <FormInput
                      name="monthlySalary"
                      type="number"
                      label="Monthly salary (INR)"
                      placeholder="Fetch automatically"
                      touched={touched}
                      errors={errors}
                      containerClass={"w-full"}
                    />
                  </div>
                  <FieldArray name="deducation">
                    {({ push, remove }) => (
                      <>
                        {values?.deducation?.map((_, index) => {
                          return (
                            <div className="w-full flex-row align-center justify-between g-05">
                              <FormInput
                                name={`deducation[${index}].amount`}
                                type="number"
                                label="Deduction monthly(if any)"
                                placeholder="Deduction (INR)"
                                touched={touched}
                                errors={errors}
                                containerClass={"w-full"}
                              />
                              <FormInput
                                name={`deducation[${index}].cause`}
                                type="text"
                                label="Cause"
                                placeholder="Cause of deduction"
                                touched={touched}
                                errors={errors}
                                containerClass={"w-full"}
                              />
                              <button
                                type="button"
                                className="addNewFieldBtn mt-1"
                                onClick={() => remove(index)}
                              >
                                <img src={CrossBtnIcon} alt="" />
                              </button>
                            </div>
                          );
                        })}
                        <button
                          type="button"
                          className="addNewFieldBtn"
                          onClick={() => push({ amount: "", cause: "" })}
                        >
                          <img
                            src={PlusBtnIcon}
                            alt=""
                            style={{ width: "2rem", height: "2rem" }}
                          />
                        </button>
                      </>
                    )}
                  </FieldArray>
                  <div className="w-full flex-row align-center justify-between g-05">
                    <h3 className="t-18 poppins-medium color-textColor weight-500 w-half">
                      Gross salary:
                    </h3>
                    <FormInput
                      name="grossSalary"
                      type="number"
                      label=""
                      placeholder="Fetch automatically"
                      touched={touched}
                      errors={errors}
                      containerClass={"w-full"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button type="submit" className="actionBtn w-full">
            Create
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default SalarySlabForm;
